<template>
<div>
  
  <section class="content">
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('loan-plan-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Loan Plan List</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('loan-plan-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click.once="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th>Sr. No.</th>
                <th>Plan Name</th>
                <th class="hidden-xs">Plan Type</th>
                <th>Loan</th>
                <th class="hidden-xs">Disbursement</th>
                <th class="hidden-xs">Collection</th>
                
                <th class="hidden-xs">Tenure</th>
                <!-- <th class="hidden-xs">EMI</th> -->
                
                <th class="hidden-xs">Status</th>
                <th>Action</th>

                <!-- <th v-if="$gate.isAdmin()">Status</th>
                <th>Image</th>
                <th v-if="$gate.isAdmin()">Modify</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows.data" :key="index">
                <td>{{ (index + pagination.from) }}</td>
                <td>{{ row.name }}</td>
                <td class="hidden-xs">{{ row.planType }}</td>
                <td><span v-if="row.planType === 'normalReduced' || row.planType === 'special' || row.planType === 'custom' ">
                      {{getplanamt(row)}}
                    </span>
                    <span v-else>
                      {{row.amount}}
                    </span>
                </td>
                <td class="hidden-xs">{{ row.amount }}</td>
                <td class="hidden-xs">{{ row.recoveryType }}</td>
                
                <td class="hidden-xs">{{ row.noOfPayments }}</td>
                <!-- <td class="hidden-xs">{{ row.emi }}</td> -->
                
                <td class="hidden-xs">
                  <div v-if="row.status == 'active'">
                    <span class="label label-success">Active</span>
                  </div>
                  <div v-else>
                    <span class="label label-danger">InActive</span>
                  </div>
                </td>
                <td>
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                      Task <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <li v-if="canAccess('loan-plan-view')">
                        <a @click="viewPlan(row)"><i class="fa fa-eye"></i> View</a>
                      </li>
                      <li v-if="canAccess('loan-plan-update')">
                        <a @click="editModal(row)"><i class="fa fa-pencil"> </i> Update</a>
                      </li>
                      <li v-if="canAccess('loan-plan-delete')">
                        <a @click="deleteModal(row.id)"><i class="fa fa-trash"> </i> Delete</a>
                      </li>
                    </ul>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->

        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

    </section>

      <div class="modal fade" id="viewPlan">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header bg-aqua">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">Plan Details</h4>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-6">
                  <div class="card">
              
                  <!-- /.card-header -->
                  <div class="card-body" v-if="planDetail">
                    <ul class="list-group ui-sortable">
                      <li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Plan Name</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.name}}</a> 
                      </li>
                      <li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Plan Type</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.planType}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Recovery Type</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.recoveryType}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Type of Interest</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.typeOfInterest}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Rate of Interest (%)</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.rateOfInterest}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">EMI</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{calculatorData.emi}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">No. of Payments</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.noOfPayments}}</a>
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Include GST</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.includeGst}}</a> 
                      </li>
                      <li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Status</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.status}}</a> 
                      </li>
                      
                    </ul>
                  </div>
                  <!-- /.card-body -->
                </div>
                </div>
                <div class="col-md-6">
                  <div class="card">
              
                  <!-- /.card-header -->
                  <div class="card-body" v-if="planDetail">
                    <ul class="list-group ui-sortable">
                      <li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Create Date</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.created_at}}</a> 
                      </li>
                      <li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Amount</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> <span v-if="planDetail.planType === 'normalReduced' || planDetail.planType === 'special' || planDetail.planType === 'custom' ">
                          {{getplanamt(planDetail)}}
                        </span>
                        <span v-else>
                          {{planDetail.amount}}
                        </span></a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">File Charge</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.fileCharge}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">File Charge Include Amount</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.fileChargeIncludeAmt}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text" v-if="planDetail.planType == 'normalReduced'">Processing Fee Amt</span>
                        <span class="text" v-if="planDetail.planType !== 'normalReduced'">Processing Fee (%)</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.processingFee}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Processing Fee Include Amount</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.processingFeeIncludeAmt}}</a>
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text" v-if="planDetail.planType == 'normalReduced'">Insurance Fee Amt</span>
                        <span class="text" v-if="planDetail.planType !== 'normalReduced'">Insurance Fee (%)</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.insuranceFee}}</a> 
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Insurance Fee Include Amount</span>
                        <!-- Emphasis label -->
                        <a class="pull-right"> {{planDetail.insuranceFeeIncludeAmt}}</a>  
                      </li><li class="list-group-item">
                        <!-- todo text -->
                        <span class="text">Advance Installment</span>
                        <!-- Emphasis label -->
                        <small class="label label-warning" v-if="planDetail.advanceInstallment"><i class="far fa-clock"></i> {{planDetail.advanceInstallment}}</small> 
                      </li>
                      
                    </ul>
                  </div>
                  <!-- /.card-body -->
                </div>
                </div>
                </div>
                
                
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger pull-left" data-dismiss="modal">Close</button>
                
              </div>
            </div>
            <!-- /.modal-content -->
          </div>
          <!-- /.modal-dialog -->
        </div>
      <!-- /.row -->
      <div class="modal fade" id="newModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 v-show="!editMode" class="modal-title">Add New Plan</h4>
              <h4 v-show="editMode" class="modal-title">Update Plan</h4>
              <h4 class="modal-title" v-show="emiCal">Plan EMI</h4>
            </div>

            <div v-show="emiCal" class="modal-body">
              <!-- right column -->
                <!-- general form elements disabled -->
                <div class="card card-warning">
                  <!-- /.card-header -->
                  <div class="card-body">
                    <div class="table">
                      <table class="table table-bordered">
                        <thead>
                          <th>Number Of Payments : {{calculatorData.noOfPayment}}</th>
                          <th>Total Amount To pay : {{calculatorData.totalAmtToPay}}</th>
                          <th>Preloan EMI Interest : {{calculatorData.preLoanEmiInterest}}</th>
                          <th v-if="this.form.planType === 'normal'">Principal Amount : {{this.form.amount}}</th>
                          <th v-if="this.form.planType !== 'normal'">Paid Amount : {{this.form.amount}}</th>
                        </thead>
                      </table>
                    </div>
                    
                    <div class="row table-responsive">
                      <vue-good-table
                        :columns="TableColumn"
                        :rows="calculatorEmi"
                        :line-numbers="true"
                        styleClass="vgt-table condensed"
                        max-height="400px"
                        :fixed-header="true"
                        :sort-options="{
                          enabled: false,
                        }"
                      >
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'id'">
                            <a :href="props.row.id" class="btn btn-info btn-xs"
                              ><i class="fa fa-eye"></i
                            ></a>
                            <a
                              :href="props.row.id"
                              class="btn btn-success btn-xs"
                              ><i class="fa fa-pencil-alt"></i
                            ></a>
                          </span>
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                      <!-- {{calculatorData}} -->
                    </div>
                  </div>
                </div>
            </div>

            <form
              v-show="!emiCal"
              @submit.prevent="editMode ? updateLoanPlan() : createLoanPlan()"
            >
              <div class="modal-body">
                <!-- right column -->
                
                  <div class="card card-warning">
                    <!-- /.card-header -->
                    <div class="card-body">
                      <div class="row">
                        <div class="col-sm-6">
                          <!-- text input -->
                          <div class="form-group" v-if="!this.editMode">
                            <label
                              >Select Loan Type
                              <span class="red">*</span></label
                            >
                            <select
                              v-model="form.planType"
                              name="planType"
                              class="form-control"
                              @change="setPlanDefaultValue"
                              :class="{ 'is-invalid': form.errors.has('planType') }"
                            >
                              <option value="">Select Loan Plan</option>
                              <option value="normal">Normal Plan</option>
                              <option value="normalReduced">Normal Reduced Plan</option>
                              <option value="special">Special Plan</option>
                              <option value="custom">Custom Plan</option>
                              <option value="manual">Manual Plan</option>
                              <option class="red" value="interest"><span class="red">Premium</span> (Interest Plan)</option>
                            </select>
                            <has-error :form="form" field="planType"></has-error>
                          </div>
                          <div class="form-group"  v-if="this.editMode">
                            <label
                              >Select Loan Type
                              <span class="red">*</span></label
                            >
                            <select
                              v-model="form.planType"
                              name="planType"
                              class="form-control"
                              @change="setPlanDefaultValue"

                              :class="{ 'is-invalid': form.errors.has('planType') }"
                              disabled
                            >
                              <option value="">Select Loan Plan</option>
                              <option value="normal">Normal Plan</option>
                              <option value="normalReduced">Normal Reduced Plan</option>
                              <option value="special">Special Plan</option>
                              <option value="custom">Custom Plan</option>
                              <option value="manual">Manual Plan</option>
                              <option class="red" value="interest"><span class="red">Premium</span> (Interest Plan)</option>

                            </select>
                            <has-error :form="form" field="planType"></has-error>
                          </div>
                          <div class="form-group">
                            <label>Plan Name <span class="red">*</span></label>
                            <input
                              v-model="form.name"
                              type="text"
                              name="name"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('name') }"
                            />
                            <has-error :form="form" field="name"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'normal' || this.form.planType === 'normalReduced' || this.form.planType === 'interest'">
                            <label>Rate of Interest <span class="red">*</span></label>
                            <input
                              v-model="form.rateOfInterest"
                              type="number"
                              name="rateOfInterest"
                              step=".001"
                              class="form-control"
                              :class="{ 'is-invalid': form.errors.has('rateOfInterest') }"
                            />
                            <has-error :form="form" field="rateOfInterest"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'custom'">
                            <label
                              >Payments Details <span class="red">*</span></label
                            ><br>
                            
                                <span v-for="(input,k) in form.plan_details" :key="k" style="display: flex; flex-flow: row wrap;
                                  align-items: center;">
                                <input
                                  v-model="input.emi"
                                  type="number"
                                  name="noOfPayments"
                                  style="width:42% "
                                  class="form-control"
                                  placeholder="EMI"
                                  :class="{
                                    'is-invalid': form.errors.has('noOfPayments'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="noOfPayments"
                                ></has-error>
                              
                                <input
                                  v-model="input.noOfPayments"
                                  type="number"
                                  name="noOfPayments"
                                  class="form-control"
                                  style="width:42%"
                                  placeholder="No. of payments"
                                  :class="{
                                    'is-invalid': form.errors.has('noOfPayments'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="noOfPayments"
                                ></has-error>
                                &nbsp;
                                  <span>
                                    <i class="fa fa-minus-circle btn-danger" @click.once="remove(k)" v-show="k || ( !k && form.plan_details.length > 1)"></i>
                                    <i class="fa fa-plus-circle btn-success" @click.once="add(k)" v-show="k == form.plan_details.length-1"></i>
                                  </span>
                                </span>
                                
                            
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'manual'">
                            <label
                              >Payments Details <span class="red">*</span></label
                            ><br>
                            
                                <span v-for="(input,k) in form.plan_details" :key="k" style="display: flex; flex-flow: row wrap;
                                  align-items: center;">

                                <input
                                  v-model="input.principal"
                                  type="number"
                                  name="principal"
                                  class="form-control"
                                  style="width:42%"
                                  placeholder="Principal"
                                  :class="{
                                    'is-invalid': form.errors.has('principal'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="principal"
                                ></has-error>

                                <input
                                  v-model="input.intrest"
                                  type="number"
                                  name="intrest"
                                  class="form-control"
                                  style="width:42%"
                                  placeholder="Interest"
                                  :class="{
                                    'is-invalid': form.errors.has('intrest'),
                                  }"
                                />
                                <has-error
                                  :form="form"
                                  field="intrest"
                                ></has-error>
                              
                                &nbsp;
                                  <span>
                                    <i class="fa fa-minus-circle btn-danger" @click.once="remove(k)" v-show="k || ( !k && form.plan_details.length > 1)"></i>
                                    <i class="fa fa-plus-circle btn-success" @click.once="addManualEmi(k)" v-show="k == form.plan_details.length-1"></i>
                                  </span>
                                </span>
                                
                            
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'custom' && this.form.planType !== 'manual'">
                            <label
                              >Number of EMI <span class="red">*</span></label
                            >
                            <input
                              v-model="form.noOfPayments"
                              type="number"
                              name="noOfPayments"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('noOfPayments'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="noOfPayments"
                            ></has-error>
                          </div>
                          
                          <div class="form-group" v-if="this.form.planType === 'special'">
                            <label
                              >EMI Amt. <span class="red">*</span></label
                            >
                            <input
                              v-model="form.emi"
                              type="number"
                              name="emi"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('emi'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="emi"
                            ></has-error>
                          </div>

                          <div class="form-group">
                            <label
                              >Recovery type
                              <span class="red">*</span></label
                            >
                            <select
                              v-model="form.recoveryType"
                              name="recoveryType"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has(
                                  'recoveryType'
                                ),
                              }"
                            >
                              <option value="">Recovery type</option>
                              <option value="Daily">Daily</option>
                              <option value="Weekly">Weekly</option>
                              <option value="BiWeekly">BiWeekly</option>
                              <option value="HalfMonth">Half Month</option>
                              <option value="Monthly">Monthly</option>
                              <option value="Year">Yearly</option>
                              <option value="Year">One Time</option>

                            </select>
                            <has-error
                              :form="form"
                              field="recoveryType"
                            ></has-error>
                          </div>
                          
                          <div class="form-group">
                            <label
                              >No of Advance Installment <span class="red">*</span></label
                            >
                            <select
                              v-model="form.noOfAdvanceInstallment"
                              name="noOfAdvanceInstallment"
                              class="form-control"
                              placeholder="no of advance installation"
                              :class="{
                                'is-invalid': form.errors.has('noOfAdvanceInstallment'),
                              }"
                            >
                              <option value="">No of Advance Installment</option>
                              <option value="0">0</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                            </select>
                            <has-error :form="form" field="noOfAdvanceInstallment"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Holiday Exclude <span class="red">*</span></label
                            >
                            <select
                              v-model="form.holidayInclude"
                              name="holidayInclude"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('holidayInclude'),
                              }"
                            >
                              <option value="">Holiday Include</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            <has-error :form="form" field="holidayInclude"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'normal' || this.form.planType === 'normalReduced'">
                            <label
                              >Type of Interest
                              <span class="red">*</span></label
                            >
                            <select 
                              v-model="form.typeOfInterest"
                              name="typeOfInterest"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('typeOfInterest'),
                              }"
                            >
                              <option value="">Select Interest Type</option>
                              <option value="reduced">Reduced</option>
                              <option value="fixed">Flat</option>
                            </select>
                            <has-error
                              :form="form"
                              field="typeOfInterest"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >GST Charge Include <span class="red">*</span></label
                            >
                            <select
                              v-model="form.includeGst"
                              @change="paidAmount"
                              name="includeGst"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('includeGst'),
                              }"
                            >
                              <option value="">Select</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            <has-error :form="form" field="includeGst"></has-error>
                          </div>
                        </div>

                        <div class="col-sm-6">
                          <div class="form-group" v-if="this.form.planType === 'normal'">
                            <label
                              >Plan Amount <span class="red">*</span></label
                            >
                            <input
                              v-model="form.amount"
                              type="number"
                              name="amount"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('amount'),
                              }"
                            />
                            <has-error :form="form" field="amount"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Plan Amount <span class="red">*</span></label
                            >
                            <input
                              v-model="form.planAmount"
                              type="number"
                              name="planAmount"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('planAmount'),
                              }"
                            />
                            <has-error :form="form" field="planAmount"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Paid Amount <span class="red">*</span></label
                            >
                            <input
                              v-model="form.amount"
                              type="number"
                              name="amount"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('amount'),
                              }"
                              readonly
                            />
                            <has-error :form="form" field="amount"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >File Charge Include <span class="red">*</span></label
                            >
                            <select
                              v-model="form.fileChargeIncludeAmt"
                              name="fileChargeIncludeAmt"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('fileChargeIncludeAmt'),
                              }"
                            >
                              <option value="">Select</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            <has-error :form="form" field="fileChargeIncludeAmt"></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >File Charge
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.fileCharge"
                              type="number"
                              name="fileCharge"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('fileCharge'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="fileCharge"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Processing Fee Charge Include <span class="red">*</span></label
                            >
                            <select
                              v-model="form.processingFeeIncludeAmt"
                              name="processingFeeIncludeAmt"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('processingFeeIncludeAmt'),
                              }"
                            >
                              <option value="">Select</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            <has-error :form="form" field="processingFeeIncludeAmt"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Processing Fee In Percentage (%)
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.processingFeePer"
                              type="number"
                              step=".01"
                              name="processingFeePer"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('processingFeePer'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="processingFeePer"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Processing Fee In Amount
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.processingFee"
                              type="number"
                              name="processingFee"
                              class="form-control"
                              readonly
                              :class="{
                                'is-invalid': form.errors.has('processingFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'normal'">
                            <label
                              >Processing Fee In Percentage (%)
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.processingFee"
                              type="number"
                              name="processingFee"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('processingFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="processingFee"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Insurance Fee Charge Include <span class="red">*</span></label
                            >
                            <select
                              v-model="form.insuranceFeeIncludeAmt"
                              name="insuranceFeeIncludeAmt"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('insuranceFeeIncludeAmt'),
                              }"
                            >
                              <option value="">Select</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                            <has-error :form="form" field="insuranceFeeIncludeAmt"></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Insurance Fee In Percentage (%)
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.insuranceFeePer"
                              type="number"
                              step=".01"
                              name="insuranceFeePer"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('insuranceFeePer'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="insuranceFeePer"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType !== 'normal'">
                            <label
                              >Insurance Fee In Amount
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.insuranceFee"
                              type="number"
                              name="insuranceFee"
                              class="form-control"
                              readonly
                              :class="{
                                'is-invalid': form.errors.has('insuranceFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="insuranceFee"
                            ></has-error>
                          </div>
                          <div class="form-group" v-if="this.form.planType === 'normal'">
                            <label
                              >Insurance Fee In Percentage (%)
                              <span class="red">*</span></label
                            >
                            <input
                              v-model="form.insuranceFee"
                              type="number"
                              name="insuranceFee"
                              class="form-control"
                              @change="paidAmount"
                              :class="{
                                'is-invalid': form.errors.has('insuranceFee'),
                              }"
                            />
                            <has-error
                              :form="form"
                              field="insuranceFee"
                            ></has-error>
                          </div>
                          <div class="form-group">
                            <label
                              >Select Status <span class="red">*</span></label
                            >
                            <select
                              v-model="form.status"
                              name="status"
                              class="form-control"
                              :class="{
                                'is-invalid': form.errors.has('status'),
                              }"
                            >
                              <option value="">Select Status View</option>
                              <option value="active">Active</option>
                              <option value="inActive">Inactive</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                
              </div>
              <div class="modal-footer text-center">
                <button
                  v-show="!editMode"
                  type="submit"
                  class="btn btn-success"
                >
                  SAVE
                </button>
                <button v-show="editMode" type="submit" class="btn btn-primary">
                  Update
                </button>
                <button
                  type="button"
                  @click="calculateEMI"
                  class="btn btn-success"
                >
                  Calculate EMI
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                >
                  CANCEL
                </button>
              </div>
            </form>
            <div v-show="emiCal" class="modal-footer text-center">
              <button @click="backToLoanPlan" class="btn btn-primary">
                BACK
              </button>

              <button type="button" class="btn btn-danger" data-dismiss="modal">
                CANCEL
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->

</div>
</template>

<script>
export default {
  name: 'LoanPlan',
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      planDetail: {},
      form: new Form({
        id: '',
        name: '',
        planAmount: 0,
       // type: '',
        amount: 0,
      //  noOfYears: '',
      //  installment: '',
      //  noOfPaymentYear: '',
      //  installmentMode: '',
      //  rateOfIntrest: '',
        typeOfInterest: 'fixed',
        planType: '',
        rateOfInterest: 0,
        noOfPayments: '',
        emi: 0,
        principal: 0,
        intrest: 0,
        recoveryType: '',
        noOfAdvanceInstallment: 0,
        fileCharge: 0,
        fileChargeIncludeAmt: 'false',
        processingFee: 0,
        processingFeePer: 0,
        processingFeeIncludeAmt: 'false',
        processingFeeType: 'percent',
        insuranceFee: 0,
        insuranceFeePer: 0,
        insuranceFeeIncludeAmt: 'false',
        insuranceFeeType: 'percent',
        totalAmtToPay: 0,
        includeGst: 'false',
        holidayInclude: 'false',
        plan_details: [
          {
            principal: '',
            intrest: '',
            emi: '',
            noOfPayments: ''
          }
        ],
        status: false
      }),
      editMode: false,
      emiCal: false,
      calculatorEmi: [],
      calculatorData: {},
      rows: [],
      TableColumn: [
        { label: 'Date', field: 'date' },
        { label: 'Base', field: 'principal' },
        { label: 'Interest', field: 'interest' },
        { label: 'EMI', field: 'emi' },
        { label: 'Balance', field: 'balance' }
      ]
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    setPlanDefaultValue () {
      this.form.amount = 0
      this.form.processingFee = 0
      this.form.insuranceFee = 0
      this.form.fileCharge = 0
      this.form.fileChargeIncludeAmt = 'false'
      this.form.processingFeeIncludeAmt = 'false'
      this.form.insuranceFeeIncludeAmt = 'false'
      if (this.form.planType !== 'normal') {
        this.form.processingFeeType = 'fixed'
        this.form.insuranceFeeType = 'fixed'
      } else {
        this.form.processingFeeType = 'percent'
        this.form.insuranceFeeType = 'percent'
      }
    },
    getplanamt (row) {
      var fpi = 0
      var gstAmt = 0
      if (row.fileChargeIncludeAmt === 'true') {
        fpi += parseInt(row.fileCharge)
      }
      if (row.processingFeeIncludeAmt === 'true') {
        fpi += parseInt(row.processingFee)
      }
      if (row.insuranceFeeIncludeAmt === 'true') {
        fpi += parseInt(row.insuranceFee)
      }
      if (row.includeGst === 'true') {
        gstAmt = fpi * 18 / 100
        fpi += parseInt(gstAmt)
      }
      return row.amount + fpi
    },
    paidAmount () {
      if (this.form.planType !== 'normal') {
        var fpi = 0
        var gstAmt = 0
        this.form.processingFee = this.form.planAmount * this.form.processingFeePer / 100
        this.form.insuranceFee = this.form.planAmount * this.form.insuranceFeePer / 100
        this.form.amount = 0
        // this.form.amount = this.form.planAmount
        if (this.form.processingFee > 0 && this.form.processingFeeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.processingFee)
        }
        if (this.form.fileCharge > 0 && this.form.fileChargeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.fileCharge)
        }
        if (this.form.insuranceFee > 0 && this.form.insuranceFeeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.insuranceFee)
        }
        if (this.form.includeGst === 'true') {
          // console.log('check')
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        this.form.amount = this.form.planAmount - fpi
      }
    },
    add (index) {
      this.form.plan_details.push({emi: '', noOfPayments: ''})
    },
    addManualEmi (index) {
      this.form.plan_details.push({principal: '', intrest: ''})
    },
    remove (index) {
      this.form.plan_details.splice(index, 1)
    },
    newModal () {
      this.form.reset()
      this.editMode = false
      this.emiCal = false
      $('#newModal').modal({backdrop: 'static', keyboard: false})
    },
    createLoanPlan () {
      this.$axios
        .post('loanplan', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Loan Plan Added Successfully'
          })
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    viewPlan (row) {
      // alert('hello')
      this.form.reset()
      this.planDetail = row
      $('#viewPlan').modal({backdrop: 'static', keyboard: false})
      // $('#viewPlan').modal('show')
      this.form.fill(row)
      this.calculateEMI()
    },
    editModal (row) {
      this.form.reset()
      this.form.insuranceFee = 0
      this.editMode = true
      this.emiCal = false
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      this.form.fill(row)
      if (row.processingFeeType === 'fixed' && row.planType === 'normal') {
        this.form.processingFeePer = (this.form.processingFee * 100 / row.amount).toFixed(2)
      }
      if (this.form.planType === 'normalReduced' || this.form.planType === 'interest' || this.form.planType === 'special' || this.form.planType === 'custom') {
        this.form.insuranceFeeType = 'fixed'
        var fpi = 0
        var gstAmt = 0
        // this.form.amount = this.form.planAmount
        if (this.form.processingFee > 0 && this.form.processingFeeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.processingFee)
        }
        if (this.form.fileCharge > 0 && this.form.fileChargeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.fileCharge)
        }
        if (this.form.insuranceFee > 0 && this.form.insuranceFeeIncludeAmt === 'true') {
          // console.log('check')
          fpi += parseInt(this.form.insuranceFee)
        }
        if (this.form.includeGst === 'true') {
          // console.log('check')
          gstAmt = fpi * 18 / 100
          fpi += parseInt(gstAmt)
        }
        this.form.planAmount = this.form.amount + fpi
        this.form.processingFeePer = (this.form.processingFee * 100 / this.form.planAmount).toFixed(2)
        this.form.insuranceFeePer = (this.form.insuranceFee * 100 / this.form.planAmount).toFixed(2)
      }
      if (this.form.planType === 'normal') {
        this.form.insuranceFeeType = 'percent'
      }
    },
    deleteModal (id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('loanplan/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
              Fire.$emit('AfterCreate')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    backToLoanPlan () {
      this.emiCal = false
    },
    // loadData () {
    //   let loader = this.$loading.show()
    //   this.$axios
    //     .get('loanplan?all=all', {
    //       headers: { Authorization: 'Bearer ' + localStorage.token }
    //     })
    //     .then((response) => response.data)
    //     .then((data) => {
    //       loader.hide()
    //       this.rows = data.data
    //     })
    //     .catch(function (error) {
    //       console.log(error)
    //     })
    // },
    changeFilter (page = null, pg = null) {
      let loader = this.$loading.show()
      var pageUrl = ''
      if (this.pagination.first_page_url && pg === 'first') {
        pageUrl += this.pagination.first_page_url
      } else if (this.pagination.last_page_url && pg === 'last') {
        pageUrl += this.pagination.last_page_url
      } else if (this.pagination.next_page_url && pg === 'next') {
        pageUrl += this.pagination.next_page_url
      } else if (this.pagination.prev_page_url && pg === 'prev') {
        pageUrl += this.pagination.prev_page_url
      } else if (this.pagination.path != null) {
        pageUrl += this.pagination.path
      } else {
        pageUrl += 'loanplan'
      }

      if (pg == null) {
        pageUrl += `?per_page=${this.per_page}`
      } else {
        pageUrl += `&per_page=${this.per_page}`
      }
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.rows = data.data
          this.pagination = data.data
        }).catch(function (error) {
          loader.hide()
          console.log(error)
        })
    },
    updateLoanPlan () {
      // console.log('update data');

      this.$axios
        .put('loanplan/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Loan Plan Updated Successfully'
          })
        })
        .catch(
          function (error) {
            if (error.response.data.error) {
              var result = []
              var er = error.response.data.error
              for (var l in er) {
                if (er.hasOwnProperty(l)) {
                  result.push(l + ': ' + er[l])
                }
              }
              Toast.fire({ icon: 'error', title: result.join('\n') })
            }
            if (error.response.data.message) {
              let er = error.response.data.message
              Toast.fire({ icon: 'error', title: er })
            }
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },

    calculateEMI () {
      let loader = this.$loading.show()
      if (this.form.insuranceFee === null) {
        this.form.insuranceFee = 0
      }
      if (
        this.form.amount === '' ||
        this.form.recoveryType === '' ||
        this.form.holidayInclude === ''
      ) {
        Toast.fire({
          icon: 'error',
          title: 'Please Fill All Field, Try Again'
        })
      } else {
        var planDetail = ''
        if (this.form.planType === 'custom') {
          for (var i = 0; i < this.form.plan_details.length; i++) {
            var j = i + 1
            planDetail = planDetail + '&plan_detail[0][' + j + ']=[emi=' + this.form.plan_details[i]['emi'] + ',noOfPayments=' + this.form.plan_details[i]['noOfPayments'] + ']'
          }
        } else if (this.form.planType === 'manual') {
          for (i = 0; i < this.form.plan_details.length; i++) {
            j = i + 1
            planDetail = planDetail + '&plan_detail[0][' + j + ']=[principal=' + this.form.plan_details[i]['principal'] + ',intrest=' + this.form.plan_details[i]['intrest'] + ']'
          }
        } else {
          if (this.form.planType === 'special') {
            planDetail = '&emi=' + this.form.emi + '&noOfPayments=' + this.form.noOfPayments
          } if (this.form.planType === 'normal' || this.form.planType === 'normalReduced' || this.form.planType === 'interest') {
            planDetail = '&noOfPayments=' + this.form.noOfPayments
          }
        }
        this.$axios
          .get('loanplan/emi?principal=' +
              this.form.amount +
              '&rate=' +
              this.form.rateOfInterest +
              '&type=' +
              this.form.typeOfInterest +
              '&recoveryType=' +
              this.form.recoveryType +
              '&noOfAdvanceInstallment=' +
              this.form.noOfAdvanceInstallment +
              '&holidayInclude=' +
              this.form.holidayInclude +
              '&planType=' +
              this.form.planType +
              '&fileCharge=' +
              this.form.fileCharge +
              '&fileChargeIncludeAmt=' +
              this.form.fileChargeIncludeAmt +
              '&processingFeeType=' +
              this.form.processingFeeType +
              '&processingFee=' +
              this.form.processingFee +
              '&processingFeeIncludeAmt=' +
              this.form.processingFeeIncludeAmt +
              '&insuranceFeeType=' +
              this.form.insuranceFeeType +
              '&insuranceFee=' +
              this.form.insuranceFee +
              '&insuranceFeeIncludeAmt=' +
              this.form.insuranceFeeIncludeAmt +
              '&includeGst=' +
              this.form.includeGst +
              planDetail,
            {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            // console.log(data)
            loader.hide()
            this.calculatorEmi = data.installments
            this.calculatorData = data.data
            this.form.totalAmtToPay = this.calculatorData.totalAmtToPay
            this.emiCal = true
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: error.response.data.error })
              loader.hide()
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
    }
  },

  created () {
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.red {
  color: red;
}
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// LoanPlan.vue?30ea1ac0